// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import BreadcrumbsPresentationPropsDefault from "@insite/mobius/Breadcrumbs/presentationProps";
import { xBaseTheme } from "@rpsc/XDL/types";
import { xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...BreadcrumbsPresentationPropsDefault,
        mergeCss: true,
        typographyProps: {
            size: 14,
            weight: "normal",
            ellipsis: true,
            css: css`
                max-width: 50ch;
                letter-spacing: 0;
                line-height: 17px;
                word-wrap: break-word;
                ${xScreen("lte", "sm")} {
                    max-width: 25ch;
                }
            `,
        },

        css: css`
            flex-wrap: wrap;
            gap: 8px;
            @media print {
                display: none;
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
